import React, { FunctionComponent, memo, useRef } from 'react'
import styles from './TagElement.module.sass'
import { Tag } from '../../../../responses/tags'
import clsx from 'clsx'
import { motion } from 'framer-motion'
import { useRipple } from 'react-use-ripple/dist'
import CloseIcon from '../../../../../files/close.svg'

interface Props {
    className?: string,
    tag: Tag,
    inverted?: boolean,
    delete?: boolean,
    disabled?: boolean,
    onClick?: () => void,
}

const TagElement: FunctionComponent<Props> = props => {
    const ref = useRef<HTMLDivElement>(null)
    useRipple(ref, {disabled: props.disabled})

    return <motion.div
        ref={ref}
        layout
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className={clsx(props.className, styles.tag, {
            [styles.delete]: props.delete,
            [styles.inverted]: props.inverted,
            [styles.interactive]: props.onClick && !props.disabled,
        })}
        onClick={props.disabled? undefined: props.onClick}
    >
        <span>{props.tag?.name}</span>
        {props.children}
        {
            props.delete && <CloseIcon className={styles.icon}/>
        }
    </motion.div>
}

export default memo(TagElement)